import { useCallback, useEffect } from 'react'

import SimpleDate from 'app/common/classes/simple-date'
import { useDataBoxSelector } from 'app/common/data-box-store'
import {
  PlainDatePeriodBox,
  dateFormat,
} from 'app/common/ui-next/_filter-compilations/plain-date-period'
import { getID } from 'app/common/ui-next/plain-selector'
import {
  periodFilter,
  schoolYearFilter,
  schoolYearFilterSelection,
} from 'app/dataProviders/filter-items'

type Props = { id: string; pending: boolean }

export const PeriodFilter = ({ id, pending }: Props) => {
  const years = useDataBoxSelector(schoolYearFilter, () => schoolYearFilter.data)
  const selectedYears = useDataBoxSelector(
    schoolYearFilterSelection,
    () => schoolYearFilterSelection.data,
  )
  const selectedYear = years.find((year) => String(getID(year)) === selectedYears[0])

  const getDefaultState = useCallback(() => {
    const today = SimpleDate.createToday()
    const dateTo =
      selectedYear && selectedYear.dateFinish.isBefore(today)
        ? selectedYear.dateFinish
        : today
    const [monthStartValue] = dateTo.getPeriod(SimpleDate.units.month, dateFormat)
    const monthStart = new SimpleDate(monthStartValue, dateFormat)
    const dateFrom =
      selectedYear && monthStart.isBefore(selectedYear.dateStart)
        ? selectedYear.dateStart
        : monthStart
    return [
      dateFrom.getStringFormatted(dateFormat),
      dateTo.getStringFormatted(dateFormat),
    ]
  }, [selectedYear])

  useEffect(() => {
    const defaultState = getDefaultState()
    periodFilter.setDefault(defaultState)
    periodFilter.updateData(() => defaultState)
  }, [getDefaultState])

  const dateDisabledStatus = useCallback(
    (value: string, format: string, unit = 'day') => {
      const date = new SimpleDate(value, format)
      const today = SimpleDate.createToday()
      const dateTo =
        selectedYear && selectedYear.dateFinish.isBefore(today)
          ? selectedYear.dateFinish
          : today
      const simpleDateUnit = SimpleDate.getSimpleDateUnit(unit)
      if (!selectedYear) return date.isAfter(dateTo, simpleDateUnit)
      return !date.isBetween(selectedYear.dateStart, dateTo, simpleDateUnit, '[]')
    },
    [selectedYear],
  )

  return (
    <PlainDatePeriodBox
      id={id}
      label="Период времени"
      loading={pending}
      dateFormat={dateFormat}
      dataBoxData={periodFilter}
      getDefaultState={getDefaultState}
      dateDisabledStatus={dateDisabledStatus}
      periodLimit={1}
      periodLimitUnit="years"
    />
  )
}
